"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CUSTOM_THEME_1 = exports.DEFAULT_THEME_ID = void 0;
exports.DEFAULT_THEME_ID = 'aurora';
exports.CUSTOM_THEME_1 = 'customTheme1';
//# sourceMappingURL=ThemeConstant.js.map